// 配置全局访问接口地址
let commonUrl = "https://c.mcfly.club";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl